import { createFileRoute, notFound } from '@tanstack/react-router';
import { DealEditorPage, dealsQueryOptions, normalizeDealRouteParams } from '@/features/deals';

export const Route = createFileRoute('/_authed/deals/$dealId')({
  loader: ({ context, params }) => {
    const normalizedParams = normalizeDealRouteParams(params);
    if (!normalizedParams) {
      throw notFound();
    }

    void context.queryClient.prefetchQuery(dealsQueryOptions({}));
    return normalizedParams;
  },
  component: DealsEditRouteComponent,
});

function DealsEditRouteComponent() {
  const { dealId } = Route.useLoaderData();

  return <DealEditorPage mode="edit" dealId={dealId} />;
}
